<template lang="pug">
  .tk-vkb-producttable
    table.comparisonchart
      thead
        tr
          th(v-for="h in headers" :key="h.value" :class="[ h.align && `text-${ h.align }` ]")
            slot(v-if='h.slot_header' :name="`header.${ h.value }`" :item="h")
            span(v-else) {{ h.text }}

      tbody
        tr(v-for="(d, i) in pageItems" :key="i")
          td(v-for="h in headers" :key="h.value" :class="[ h.align && `text-${ h.align }` ]")
            slot(v-if="h.slot_data" :name="`item.${ h.value }`" :item="d")
            span(v-else) {{ d[h.value] }}

      tfoot(v-if="!hidePagination")
        tr: td(:colspan="headers.length"): .d-flex.align-center.justify-end.footer-pagination.pt-2
          label Anzahl pro Seite
          n-select.page-options(
            v-model="itemsPerPage"
            :items="itemsPerPageOptions"
            value-field="value"
            text-field="text"
            @input="onSelectItemsPerPage"
          )

          label.page-info {{ startIndex }}-{{ stopIndex }} von {{ totalItems }}

          a.btn-prev(:class="curPage === 1 && 'disabled'" @click.prevent="onClickPrev()")
            i.fo.fo-arrow-left

          a.btn-next(:class="curPage === totalPages && 'disabled'" @click.prevent="onClickNext()")
            i.fo.fo-arrow-right

</template>

<script>
import NSelect from './n-select.vue';

export default {
  name: 'vkb-btn',

  components: {
    NSelect
  },

  props: {
    items: {
      type: Array,
      default: () => []
    },

    headers: {
      type: Array,
      default: () => []
    },

    hidePagination: {
      type: Boolean,
      default: false
    },

    pageOptions: {
      type: Object,
      default: () => {}
    }
  },

  data: () => ({
    curPage: 1,
    itemsPerPage: 10,
    itemsPerPageOptions: [
      {
        value: 10,
        text: '10'
      },
      {
        value: 20,
        text: '20'
      },
      {
        value: 50,
        text: '50'
      },
    ]
  }),

  computed: {
    pageItems () {
      return this.items.filter((_, i) => i >= this.startIndex - 1 && i <= this.stopIndex - 1);
    },

    startIndex () {
      if (this.itemsPerPage === -1) {
        return 1;
      }
      return (this.curPage - 1) * this.itemsPerPage + 1;
    },

    stopIndex () {
      if (this.itemsPerPage === -1) {
        return this.totalItems;
      }
      const index = this.curPage * this.itemsPerPage;
      return index > this.totalItems
        ? this.totalItems
        : index;
    },

    totalItems () {
      return this.items.length;
    },

    totalPages () {
      if (this.itemsPerPage === -1) {
        return 1;
      }
      return Math.ceil(this.totalItems / this.itemsPerPage);
    }
  },

  mounted () {
    if (this.pageOptions) {
      if (this.pageOptions.items_per_page) {
        this.itemsPerPage = this.pageOptions.items_per_page;
      }

      if (this.pageOptions.items_per_page_options) {
        this.itemsPerPageOptions = this.pageOptions.items_per_page_options;
      }
    }
  },

  methods: {
    onClickNext () {
      if (this.curPage >= this.totalPages) {
        return;
      }
      this.curPage++;
    },

    onClickPrev () {
      if (this.curPage <= 1) {
        return;
      }
      this.curPage--;
    },

    onSelectItemsPerPage () {
      this.curPage = 1;
    }
  }
};
</script>

<style lang="scss">
.footer-pagination {
  .dropdown {
    margin-bottom: 0;
  }

  .page-options {
    margin-left: 20px;
  }

  .page-info {
    margin-left: 50px;
  }

  a.btn-prev,
  a.btn-next {
    margin-left: 30px !important;
  }

  @media screen and (max-width: 480px) {
    font-size: 14px;

    label {
      font-size: 14px;
    }

    .page-options {
      margin-left: 10px;
    }

    .page-info {
      margin-left: 15px;
    }

    a.btn-prev,
    a.btn-next {
      margin-left: 15px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/vkb-data-table.vue